export const riskManagementStatusLabel = {
  FAILED: 'Pré-aprovado',
  REQUESTED: 'Pré-aprovado',
  REJECTED: 'Pré-aprovado',
  APPROVED: 'Aprovado',
};
